import { Box, IconButton, Link, Typography } from "@mui/material";
import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

const Navbar = () => {
  const [activeItem, setActiveItem] = useState("home");

  const handleItemClick = (item) => {
    setActiveItem(item);
  };

  const links = [
    {
      label: "Home",
      href: "#",
    },
    {
      label: "About Me",
      href: "#AboutMe",
    },
    {
      label: "Skills",
      href: "#Skills",
    },
    {
      label: "Projects",
      href: "#Projects",
    },
    {
      label: "Articles",
      href: "#Articles",
    },
  ];

  const [openMenu, setOpenMenu] = useState(false);
  return (
    <Box position={"relative"}>
      <Box
        display={"flex"}
        px={{ xs: 2, sm: 10, lg: 20 }}
        py={3}
        height={"fit-content"}
        justifyContent={"space-between"}
      >
        <Typography variant="h6">Yogesh Yadav</Typography>

        <Box display={{ xs: "none", lg: "flex" }} gap={8}>
          {[
            links?.map((item, index) => (
              <Link
                key={index}
                href={item.href}
                sx={{
                  textDecoration: "none",
                  fontFamily: "M PLUS 1, sans-serif",
                  color: "#000",
                  fontSize: "1.2rem",
                  position: "relative",
                  overflow: "hidden",
                  "&:hover": {
                    "&::before": {
                      transition: "all .5s ease-in-out",
                      transform: "translateX(0px)",
                    },
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    bottom: 0,
                    bgcolor: "#000",
                    width: "100%",
                    height: "1px",
                    transform: "translateX(-100px)",
                  },
                }}
              >
                {item.label}
              </Link>
            )),
          ]}
        </Box>

        <IconButton
          sx={{
            display: { xs: "flex", lg: "none" },
          }}
          onClick={() => setOpenMenu(!openMenu)}
        >
          <MenuIcon />
        </IconButton>
      </Box>

      <Box
        position={"absolute"}
        display={{ xs: "flex", lg: "none" }}
        width={"100%"}
        height={openMenu ? "250px" : "0px"}
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection={"column"}
        zIndex={10}
        px={{ sm: 10, lg: 20 }}
        sx={{
          background: "rgba(255, 255, 255, 0.4)",
          backdropFilter: "blur(10px)",
          top: "20px",
          transition: "height .5s ease-in-out",
        }}
        gap={2}
      >
        <IconButton
          onClick={() => setOpenMenu(!openMenu)}
          sx={{
            display: openMenu ? "flex" : "none",
            position: "absolute",
            top: 0,
            transition: "all .5s ease-in-out",
            transitionDelay: ".5s",
            right: { xs: 20, sm: 80 },
          }}
        >
          <KeyboardBackspaceIcon />
        </IconButton>
        {[
          links?.map((item, index) => (
            <Link
              onClick={() => setOpenMenu(!openMenu)}
              key={index}
              href={item.href}
              sx={{
                textDecoration: "none",
                fontFamily: "M PLUS 1, sans-serif",
                color: "#000",
                fontSize: "1.2rem",
                position: "relative",
                overflow: "hidden",
              }}
            >
              {item.label}
            </Link>
          )),
        ]}
      </Box>
    </Box>
  );
};

export default Navbar;
